var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex flex-column h-100",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "pt-1 pb-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("list")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase",
                },
                [_vm._v(_vm._s(_vm.$t("scoutingCalendar.tasks.myTasks")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "pl-0 pr-0",
              attrs: { text: "", small: "", to: `/tasks-board` },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "white--text text-decoration-underline font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "ml-1", attrs: { small: "", color: "white" } },
                [_vm._v("keyboard_arrow_right")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "d-flex flex-column pb-1 flex-grow-1 pa-0" },
        [
          !_vm.loading
            ? [
                _c(
                  "div",
                  { staticClass: "grey lighten-4 tabs-subheader-container" },
                  [
                    _c(
                      "v-btn-toggle",
                      {
                        staticClass: "tabs-subheader d-flex w-100",
                        attrs: {
                          tile: "",
                          group: "",
                          dense: "",
                          mandatory: "",
                        },
                        model: {
                          value: _vm.tabModel,
                          callback: function ($$v) {
                            _vm.tabModel = $$v
                          },
                          expression: "tabModel",
                        },
                      },
                      [
                        _c(
                          "v-btn",
                          { staticClass: "flex-grow-1", attrs: { value: 0 } },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 font-weight-bold text-uppercase",
                              },
                              [_vm._v(_vm._s(_vm.$t("general.today")))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          { staticClass: "flex-grow-1", attrs: { value: 1 } },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 font-weight-bold text-uppercase",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("scoutingTasksBoard.period.week")
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "overflow-auto h-100 px-3 pt-2",
                    staticStyle: { background: "transparent" },
                  },
                  [
                    _vm.tabModel === 0
                      ? _c(
                          "div",
                          { staticClass: "transparent" },
                          [
                            _c("v-data-table", {
                              staticClass: "pa-0",
                              attrs: {
                                dense: "",
                                "disable-items-per-page": "",
                                "multi-sort": "",
                                headers: _vm.headers,
                                items: _vm.todayTasks,
                                "footer-props": {
                                  itemsPerPageOptions: _vm.$vuetify.breakpoint
                                    .smAndDown
                                    ? [1]
                                    : [5],
                                },
                                "sort-by": "start",
                                "sort-desc": true,
                                "no-data-text": _vm.$t(
                                  "scoutingCalendar.tasks.noData"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.name",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "py-2 d-flex align-center justify-space-between nav-link",
                                            attrs: {
                                              to: `/tasks-board?id=${item.id}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-ellipsis w-90 body-1",
                                              },
                                              [
                                                item.typeId && item.typeId !== 3
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          top: "",
                                                          color:
                                                            "lightSecondary lighten-4",
                                                          "max-width": "300",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              small:
                                                                                "",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getEventTypeIcon(
                                                                            item
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "black--text body-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getEventTypeText(
                                                                  item
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(item.name) +
                                                    "\n                "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.boardStateId",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass:
                                              "white--text monospace-font",
                                            attrs: {
                                              small: "",
                                              color:
                                                _vm.getEventStateColor(item),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getEventStateText(item)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.userAssignedIds",
                                    fn: function ({ item }) {
                                      return [
                                        item.userAssignedIds
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  color:
                                                    "lightSecondary lighten-4",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [_vm._v("person")]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "black--text body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.userAssignedNames
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2753479241
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tabModel === 1
                      ? _c(
                          "div",
                          { staticClass: "transparent" },
                          [
                            _c("v-data-table", {
                              staticClass: "pa-0",
                              attrs: {
                                dense: "",
                                "disable-items-per-page": "",
                                "multi-sort": "",
                                headers: _vm.headers,
                                items: _vm.thisWeekTasks,
                                "footer-props": {
                                  itemsPerPageOptions: _vm.$vuetify.breakpoint
                                    .smAndDown
                                    ? [1]
                                    : [5],
                                },
                                "sort-by": "start",
                                "sort-desc": true,
                                "no-data-text": _vm.$t(
                                  "scoutingCalendar.tasks.noData"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.name",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "py-2 d-flex align-center justify-space-between nav-link",
                                            attrs: {
                                              to: `/tasks-board?id=${item.id}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-ellipsis w-90",
                                              },
                                              [
                                                item.typeId && item.typeId !== 3
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          top: "",
                                                          color:
                                                            "blue-grey lighten-5",
                                                          "max-width": "300",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                                attrs,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                            },
                                                                        },
                                                                        "v-icon",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getEventTypeIcon(
                                                                            item
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "black--text body-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getEventTypeText(
                                                                  item
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(item.name) +
                                                    "\n                "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.boardStateId",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass: "white--text",
                                            attrs: {
                                              "x-small": "",
                                              color:
                                                _vm.getEventStateColor(item),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getEventStateText(item)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.userAssignedIds",
                                    fn: function ({ item }) {
                                      return [
                                        item.userAssignedIds
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  top: "",
                                                  color: "blue-grey lighten-5",
                                                  "max-width": "300",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                  },
                                                                },
                                                                "v-icon",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [_vm._v("person")]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "black--text body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.userAssignedNames
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1699971337
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(4, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }